export default __webpack_public_path__ + "static/media/8.b3ca189a.jpg";